import React from 'react';
import OfficialPage from '../OfficialPage';
import { appMethod as app } from '@utils/app';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { convertLineStyleData, getCurrentPageQueryParams } from '@utils/tools';
import './Balance.less';
import { TopNav } from '@common/top-nav/TopNav';
export default class Balance extends OfficialPage {
  state = {
    currentBalance: 0, // 当前储值金
    nowTime: '',
    year: '',
    month: '',
    earlyTime: '',
    messageData: {},
    messageParam: {},
    systemHeight: 0,
    balanceHeight: 0,
    booleanData: {
      isHideCouponNav: true,
      isHideRecordNav: true
    },
    recordsListData: {
      type: 0,
      text: '全部'
    }
  }
  constructor(porps) {
    super(porps);
    document.title = '储值金';
  }
  componentWillMount = () => {
    this.getSystemHeight()
    this.getNowMonth()
    this.getBalanceData()
    this.getBalanceTime()
    this.getAppECStoreConfig()
  }
  gotoRecharge = () => {
    app.turnToPage('/eCommerce/pages/recharge/recharge', true)
  }
  getBalanceData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getAppUserBalance',
      hideLoading: true,
      success: function (res) {
        that.setData({
          currentBalance: res.data.balance
        })
      }
    })
  }
  getBalanceTime = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetUserEarliestStoredLog',
      hideLoading: true,
      data: {
        type: that.data.recordsListData.type
      },
      success: function (res) {
        if (!res.status && res.data) {
          that.setData({
            earlyTime: res.data.month || ''
          })
          that.getMessageData()
        } else {
          that.setData({
            earlyTime: ''
          })
        }
      }
    })
  }
  getMessageData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getStoredLogByUserToken',
      hideLoading: true,
      data: {
        page: that.data.messageParam.currentPage || 1,
        type: that.data.recordsListData.type,
        month: that.data.nowTime
      },
      success: function (res) {
        let messageData = that.data.messageData
        let data = (messageData['time' + that.data.nowTime] =
          that.data.messageData['time' + that.data.nowTime] || {})
          ; (data['data'] =
            (that.data.messageData['time' + that.data.nowTime].data
              ? that.data.messageData['time' + that.data.nowTime].data.concat(
                that.parseMessageData(res.data)
              )
              : that.parseMessageData(res.data)) || ''),
            (data['month'] = that.data.month)
        data['year'] = that.data.year
          ; (data['add'] =
            res.add ||
            that.data.messageData['time' + that.data.nowTime].add ||
            0),
            (data['reduce'] =
              res.reduce ||
              that.data.messageData['time' + that.data.nowTime].reduce ||
              0),
            that.setData({
              messageData: messageData,
              'messageParam.isMore': res.is_more,
              'messageParam.currentPage': res.current_page || '',
              'messageParam.onload': false
            })
        if (that.data.balanceHeight <= that.data.systemHeight) {
          that.getBalanceHeight()
        }
      }
    })
  }
  parseMessageData = data => {
    var that = this
    let array = []
    let item = {}
    for (var i = 0; i < data.length; i++) {
      let type = data[i].type
      let content = JSON.parse(data[i].stored_content)
      let num = ''
      if (type == 1) {
        num = Number(content.price) + Number(content.g_price)
      } else if (type == 2 || type == 3 || type == 4) {
        num = Number(content.price)
      } else if (type == 5) {
        num = Number(content.g_price)
      } else if (
        type == 6 ||
        type == 10 ||
        type == 11 ||
        type == 12 ||
        type == 13 ||
        type == 14 ||
        type == 15
      ) {
        num = Number(content.price) + Number(content.g_price)
      } else if (
        type == 7 ||
        type == 8 ||
        type == 9 ||
        type == 16 ||
        type == 17 ||
        type == 18
      ) {
        num = Number(content.price)
      }
      let remark = content.remark
      remark = remark ? remark.replace('\\n', '\n') : ''
      item = {
        type: type,
        num: num ? num.toFixed(2) : num,
        time: data[i].add_time,
        remark: remark || ''
      }
      array.push(item)
    }
    return array
  }
  checkMoreMessageData = () => {
    let that = this
    if (that.data.messageParam.isMore != 0 && !that.data.messageParam.onload) {
      that.data.messageParam.currentPage++
      that.getMessageData()
      that.setData({
        'messageParam.onload': true
      })
    } else if (
      that.data.messageParam.isMore == 0 &&
      that.data.nowTime != that.data.earlyTime &&
      !that.data.messageParam.onload
    ) {
      that.data.messageParam.currentPage = 0
      that.computeTimeGetData()
      that.setData({
        'messageParam.onload': true
      })
    }
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    })
  }
  getNowMonth = () => {
    let myDate = new Date()
    let month = myDate.getMonth() + 1
    month = month < 10 ? '0' + month : month
    let year = String(myDate.getFullYear())
    this.data.year = year
    this.data.month = month
    this.data.nowTime = year + String(month)
    this.setData({
      year: year,
      month: month,
      nowTime: year + String(month)
    })
  }
  getSystemHeight = () => {
    let that = this
    app.getSystemInfo({
      success: function (res) {
        that.setData({
          systemHeight: res.windowHeight
        })
      }
    })
  }
  getBalanceHeight = () => {
    let that = this
    let rect = document.getElementById('balanceContent').getBoundingClientRect();
    that.setData({
      balanceHeight: rect.height
    })
    if (that.data.balanceHeight <= that.data.systemHeight) {
      that.computeTimeGetData()
    }
  }
  computeTimeGetData = () => {
    if (this.data.nowTime != this.data.earlyTime) {
      let month = Number(this.data.month)
      if (month == 1) {
        this.data.month = 12
        this.data.year = this.data.year - 1
        this.data.nowTime = String(this.data.year) + String(this.data.month)
      } else {
        month = month - 1
        this.data.month = month < 10 ? '0' + String(month) : String(month)
        this.data.nowTime = this.data.nowTime - 1
      }
      this.getMessageData()
    }
  }
  toggleMoreType = e => {
    let dataObj = this.data
    let dataName = ''
    if (typeof e === 'string') {
      // js调用
      dataName = e
    }
    if (typeof e === 'object' && e.currentTarget) {
      // wxml调用
      let datasetObj = e.currentTarget.dataset
      dataName = datasetObj.name
    }
    let isHide = dataObj.booleanData[dataName]
    isHide = !isHide
    this.setData({
      ['booleanData.' + [dataName]]: isHide
    })
  }
  selectRecordType = e => {
    e.stopPropagation();
    let tempArr = ['全部', '收入', '支出']
    let index = e.currentTarget.dataset.index
    if (this.data.recordsListData.type != index) {
      this.getNowMonth()
      this.setData({
        'recordsListData.type': index,
        'recordsListData.text': tempArr[index],
        'messageParam.currentPage': 1,
        messageData: {},
        balanceHeight: 0
      })
      this.getBalanceTime()
    }
    this.toggleMoreType('isHideRecordNav')
  }

  render() {
    const {
      showGetUserInfo,
      currentBalance,
      recordsListData,
      booleanData,
      messageData,
      storeStyle,
      earlyTime
    } = this.state
    return (
      <React.Fragment>
        <div className="balance-wrap page" id="balance">
          <TopNav title="储值金" />
          <ScrollView className="balance-contnet" scroll-y="true" lower-threshold="116" bindscrolltolower={this.checkMoreMessageData}>
            <div id="balanceContent">
              <div className="balance-detail">
                <div className="detail-text">
                  <span>当前储值金（元）</span>
                </div>
                <div className="detail-num">
                  <span>{currentBalance}</span>
                </div>
                <div className="detail-recharge" onClick={this.gotoRecharge}>
                  <span>去充值</span>
                </div>
              </div>
              <div className="stored-value-filter">
                <div className="stored-value-name">储值记录</div>
                <div
                  className="nav-content"
                  onClick={this.toggleMoreType}
                  data-name="isHideRecordNav"
                >
                  <span className="active">{recordsListData.text}</span>
                  <span className="ico-moon icon-downarrow"></span>
                  <div
                    className="coupons-cate"
                    style={convertLineStyleData(
                      'height: ' +
                      (booleanData.isHideRecordNav ? '0' : '270rpx')
                    )}
                  >
                    <div className="cate-list">
                      <div
                        className="cate-item thin-bd-b"
                        data-index="0"
                        onClick={this.selectRecordType}
                      >
                        <span className="ico-moon icon-balance-all ico-moon-cover"></span>
                        全部
                      </div>
                      <div
                        className="cate-item thin-bd-b"
                        data-index="1"
                        onClick={this.selectRecordType}
                      >
                        <span className="ico-moon icon-balance-income ico-moon-cover"></span>
                        收入
                      </div>
                      <div
                        className="cate-item thin-bd-b"
                        data-index="2"
                        onClick={this.selectRecordType}
                      >
                        <span className="ico-moon icon-balance-spending ico-moon-cover"></span>
                        支出
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="message-content">
                {Object.values(messageData).map((message, index) => {
                  return (
                    <div key={index}>
                      <div className="message-data">
                        <div className="message-item-header">
                          <div className="message-month-year">
                            <span className="message-month">
                              {message.month}
                            </span>
                            {'/' + message.year}
                          </div>
                          <div className="message-balance-payment">
                            {recordsListData.type != 2 && (
                              <div>
                                <span className="balance-symbol">+</span>
                                {message.add}
                              </div>
                            )}
                            {recordsListData.type != 1 && (
                              <div className="message-reduce">
                                <span className="balance-symbol-reduce"></span>
                                <span className="message-reduce-num">
                                  {message.reduce}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        {message.data.map((item, index) => {
                          return (
                            <div key={index}>
                              {item.type == 1 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    自主充值
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 2 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    商家充值
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 3 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    商品买卖
                                  </div>
                                  <div className="message-num minus">
                                    {item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 4 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    商品退款
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 5 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    储值券充值
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 6 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    自定义充值
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 7 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    管理员手动撤回储值金
                                  </div>
                                  <div className="message-num minus">
                                    {item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 8 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    用户数据合并
                                  </div>
                                  <div className="message-num minus">
                                    {item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 9 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    用户数据合并
                                  </div>
                                  <div className="message-num minus">
                                    {item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 11 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    三方配送赔付
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 12 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    会员权益赠送
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 13 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    连续签到赠送
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 14 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    累计签到赠送
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 15 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    储值金充值赠送
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 16 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    分享赠送
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : item.type == 17 ? (
                                <div className="message-item">
                                  <div className="message-title">
                                    分享拉新赠送
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                item.type == 18 && (
                                <div className="message-item">
                                  <div className="message-title">
                                    收藏赠送
                                  </div>
                                  <div
                                    className="message-num add"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'+' + item.num}
                                  </div>
                                  <div className="message-time">
                                    {item.time}
                                  </div>
                                  {item.remark && (
                                    <div className="message-remark">
                                      {'备注：' + item.remark}
                                    </div>
                                  )}
                                </div>
                                )
                              )}
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  )
                })}
                {!earlyTime && (
                  <div className="recharge-no-data">
                    <img
                      className="no-data-image"
                      src="http://cdn.jisuapp.cn/static/webapp/images/stored-value/none-stored-record.png"
                    />
                    <div>无相关数据</div>
                  </div>
                )}
              </div>
            </div>
          </ScrollView>
        </div>
      </React.Fragment >

    )
  }
}


// WEBPACK FOOTER //
// ./src/official-page/balance/Balance.jsx